import { FetchingActionType, PersistValueActionType } from 'features/Persist/actionTypes';
import { PersistValueReducer } from 'features/Persist/reducerTypes';
import { TimeTravelConfigResponse } from 'services/tenantManagementService';
import { VACATION_GENERAL_CONFIGURATION_FETCHING, VACATION_GENERAL_CONFIGURATION_SET } from './action';

export const vacationGeneralConfigurationReducer = (state = new PersistValueReducer<TimeTravelConfigResponse>(), action: PersistValueActionType<TimeTravelConfigResponse> | FetchingActionType): PersistValueReducer<TimeTravelConfigResponse> => {
	switch (action.type) {
		case VACATION_GENERAL_CONFIGURATION_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case VACATION_GENERAL_CONFIGURATION_SET:
			const { value } = action as PersistValueActionType<TimeTravelConfigResponse>;

			return {
				value,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
